// this comment tells babel to convert jsx to calls to a function called jsx instead of React.createElement
/** @jsx jsx */
import { css, jsx } from '@emotion/react'
/**
 *  Global font weight
 *
 * @export
 * @enum {number}
 */
export enum FONTWEIGHT {
  LIGHTER = 300,
  REGULAR = 400,
  MEDIUM = 500,
  BOLD = 700,
  BLACK = 900,
}

/**
 * Global heading variants
 *
 * @export
 * @enum {number}
 */
export enum HEADING {
  H1 = "H1",
  H2 = "H2",
  H3 = "H3",
  H4 = "H4",
  SUB_HEADING = "SUB_HEADING",
}

/**
 *  Global description variants
 *
 * @export
 * @enum {number}
 */
export enum DESCRIPTION {
  REGULAR = "REGULAR",
  QUOTE = "QUOTE",
}

/**
 *  Global font sizes
 *
 * @export
 * @enum {number}
 */
export enum FONTSIZE {
  F10 = "10px",
  F12 = "12px",
  F14 = "14px",
  F16 = "16px",
  F18 = "18px",
  F20 = "20px",
  F22 = "22px",
  F24 = "24px",
  F26 = "26px",
  F30 = "30px",
  F32 = "32px",
  F34 = "34px",
  F36 = "36px",
  F44 = "44px",
}

/**
 * Global colors
 *
 * @export
 * @enum {number}
 */
export enum COLORS {
  C959595 = "#959595",
  C2C2C2C = "#2C2C2C",
  CF5F7FF = "#F5F7FF",
  CE3E9FF = "#E3E9FF",
  CEDEDED = "#EDEDED",
  C3E51B5 = "#3E51B5",
  CE0E0E0 = "#E0E0E0",
}

/**
 *  Global border radius
 *
 * @export
 * @enum {number}
 */
export enum BORDER_RADIUS {
  BORDER_RADIUS_5 = 5,
  BORDER_RADIUS_4 = 4,
  BORDER_RADIUS_2 = 2,
  BORDER_RADIUS_3 = 3,
  BORDER_RADIUS_8 = 8,
  BORDER_RADIUS_6 = 6,
  BORDER_RADIUS_10 = 10,
  BORDER_RADIUS_12 = 12,
  BORDER_RADIUS_16 = 16,
  BORDER_RADIUS_20 = 20,
}

/**
 * Banner caution component sizes
 *
 * @export
 * @enum {number}
 */
export enum CAUTION_SIZE {
  LARGE = "LARGE",
  REGULAR = "REGULAR",
}

export const flexCenter = css`
  display: flex;
  align-items: center;
  justify-content: center;
`

export /**
 *  Adds top margin to the component when passed inside className prop
 *
 * @param {(number)} marginTop
 * @returns
 */
const marginTop = (marginTop: number) => {
  return css`
    margin-top: ${marginTop}px;
  `
}
